import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import isRunningInReactNativeWebView from '@/utils/isRunningInReactNativeWebView';

import { MOBILE_EVENT_CLOSE } from '../types';

const MobileCloseButton = () => {
  const mobileClose = () => {
    if (isRunningInReactNativeWebView()) {
      window.ReactNativeWebView!.postMessage(JSON.stringify({ eventType: MOBILE_EVENT_CLOSE }));
    }
  };
  return (
    <>
      {isRunningInReactNativeWebView() && (
        <FontAwesomeIcon icon={faChevronLeft} className="text-3xl" onClick={mobileClose} />
      )}
    </>
  );
};

export default MobileCloseButton;
